import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { withRouter } from 'react-router'
import omit from 'lodash/omit'
import { submitAnswer } from 'common/api'
import { getUserInfo } from 'common/user'
import { renderBySource } from 'common/utils'
import styles from './index.css'
import config from 'config'

@withRouter
@observer(['practiceStore'])
export default class Controls extends Component {

  componentDidMount () {
    window.addEventListener('keydown', this.handleKeyDown);
  }

  componentWillUnmount () {
    window.removeEventListener('keydown', this.handleKeyDown);
  }

  handleKeyDown =  (event) => {
    const { practiceStore } = this.props;

    if (event.target.tagName !== 'TEXTAREA' && !(practiceStore.category === 'blank' && event.target.tagName === 'INPUT' )) {
      if (!practiceStore.show.loading) {
        if (event.keyCode === 37) {     // 左键 上一题
          if( practiceStore.hasPrevQuestion ) {
            this.handleClickPrev()
          }
        } else if (event.keyCode === 39) {  // 右键 下一题
          if ( practiceStore.hasNextQuestion ) {
            this.handleClickNext()
          }
        }
      }
    }
  }

  handleClickPrev () {
    const { router, practiceStore, location } = this.props
    const { exam, pid } = this.props.params
    const qid = practiceStore.questionIds[practiceStore.idx - 1]
    const exerciseId = sessionStorage.getItem('EXERCISE');
    if (!location.query.exerciseId) {
      location.query['exerciseId'] = exerciseId;
    }
    if (location.query.uid || getUserInfo()) {
      this.submit(false, () => {
        router.replace({
          pathname: `/${exam}/practice/${pid}/question/${qid}`,
          query: location.query
        })
      })
    } else {
      router.replace({
        pathname: `/${exam}/practice/${pid}/question/${qid}`,
        query: location.query
      })
    }
  }

  handleClickNext () {
    const { router, practiceStore, location } = this.props
    const { exam, pid } = this.props.params
    const qid = practiceStore.questionIds[practiceStore.idx + 1]
    const exerciseId = sessionStorage.getItem('EXERCISE');
    if (!location.query.exerciseId){
      location.query['exerciseId'] = exerciseId;
    }
    if (location.query.uid || getUserInfo()) {
      this.submit(false, () => {
        router.replace({
          pathname: `/${exam}/practice/${pid}/question/${qid}`,
          query: location.query
        })
      })
    } else {
      router.replace({
        pathname: `/${exam}/practice/${pid}/question/${qid}`,
        query: location.query
      })
    }
  }

  handleClickSubmit () {
    const { practiceStore, router, location } = this.props
    const { exam } = this.props.params
    if (practiceStore.category === 'speaking'){
      const userAnswer = practiceStore.userAnswer.toJSON()
      if (userAnswer.some(item => !item.answer || !item.answer.audioPath)){
        practiceStore.toggleWritingOverflow(true, 'aduioEmpty')
        return
      }
    }
    if (practiceStore.category === 'writing') {
      const userAnswer = practiceStore.userAnswer.toJSON()

      if (userAnswer.some(item => item.isOverflow)) {
        practiceStore.toggleWritingOverflow(true, 'overFlow')
        return
      }else if (userAnswer.some(item => !item.answer || !item.answer.text)){
        practiceStore.toggleWritingOverflow(true, 'empty')
        return
      }
    }

    this.submit(true, exerciseId => {
      sessionStorage.clear()

      if (practiceStore.questionIds.length <= 1) {
        router.replace({
          pathname: `/${exam}/answer`,
          query: {
            exerciseId,
            ...omit(location.query, ['exerciseId'])
          }
        })
      } else {
        this.jumpOutSite(exerciseId)
      }
    })
  }

  submit (isFinal, successCallback) {
    const { params, practiceStore, location } = this.props

    practiceStore.toggleLoading(true)
    submitAnswer({
      pid: params.pid,
      answer: sessionStorage.getItem('ALL_ANSWERS'),
      questions: JSON.stringify(practiceStore.questionIds),
      timeCost: practiceStore.costTime,
      exerciseId: sessionStorage.getItem('EXERCISE'),
      status: isFinal ? 1 : 0,
      token: getUserInfo() ? getUserInfo().token : null,
      ...omit(location.query, ['exerciseId'])
    }).then(json => {
      practiceStore.toggleLoading(false)

      if (json.code === 'onlinep10') {
        practiceStore.toggleLogin(true)
      } else if (json.code === 0) {
        // 提交成功
        sessionStorage.removeItem('ALL_ANSWERS')
        successCallback(json.data.exerciseId)
      } else {
        // TODO: 提交失败
        alert('submit failure')
      }
    })
  }

  jumpOutSite (exerciseId) {
    const { location } = this.props
    const { exam } = this.props.params
    const { token, from } = this.props.location.query
    const fromParams = from && ['adaptation', 'smart'].indexOf(from) !== -1 ? `&from=${from}&no_header=1&no_footer=1&no_meiqia=1` : ''
    if (location.query.redirect) {
      window.location.replace(`${location.query.redirect}?exerciseId=${exerciseId}`)
    } else {
      window.location.replace(`${config.site.zhike}/${exam}/report.html?exerciseId=${exerciseId}${token ?  '&token=' + token : ''}${fromParams}`)
    }
  }

  handleClickTimer () {
    const { practiceStore } = this.props

    practiceStore.toggleTimer(!practiceStore.show.timer)
  }

  handleClickAnswer () {
    const { practiceStore } = this.props

    practiceStore.toggleAnswer(!practiceStore.show.answer)
  }

  handleClickAskTeacher () {
    const { practiceStore } = this.props

    practiceStore.toggleAskTeacher(true)
  }

  handleClickCorrection () {
    const { practiceStore } = this.props

    getUserInfo() ?
    practiceStore.showCorrection(true) :
    practiceStore.toggleLogin(true)
  }

  render () {
    const { practiceStore, location } = this.props
    const { from } = location.query;
    return (
      <div className={ styles.controls }>
        <div className={ styles.group }>
          <div className={ styles.button } onClick={ () => this.handleClickTimer() }>
            { practiceStore.show.timer ? '关闭计时' : '开启计时' }
          </div>
          {
            ['adaptation', 'smart'].indexOf(from) === -1 && renderBySource(location.query, 'askTeacher', () => (
              <div className={ styles.button } onClick={ () => this.handleClickAskTeacher() }>问问老师</div>
            ))
          }
          {
            renderBySource(location.query, 'seeAnswer', () => (
              <div className={ styles.button } onClick={ () => this.handleClickAnswer() }>
                { practiceStore.show.answer ? '隐藏答案' : '偷看答案' }
              </div>
            ))
          }
        </div>
        <div className={ styles.divider }></div>
        <div className={ styles.group }>
          { practiceStore.hasPrevQuestion ? <div className={ styles.buttonPrev } onClick={ () => this.handleClickPrev() }>上一题</div> : null }
          {
            practiceStore.hasNextQuestion
              ? <div className={ styles.buttonNext } onClick={ () => this.handleClickNext() }>下一题</div>
              : <div className={ styles.buttonActive } onClick={ () => this.handleClickSubmit() }>提交</div>
          }
          {
            renderBySource(location.query, 'correction', () => (
              <div className={ styles.correctBtn } onClick={ ()=> this.handleClickCorrection() }>
                我要纠错
              </div>
            ))
          }
        </div>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Practice/Header/Controls.js
 **/